import React, { FC } from 'react';
import styled from 'styled-components/macro';
import media from 'styles/media';
import * as MESSAGES from 'constants/messages';
import { Card, ButtonS } from 'components/atoms';
import { ProfileGroupLabel } from 'components/molecules';
import { ProfileFormItems } from 'types/profile';
import NewGraduateProfileSkillsAndPreferredConditionsContents from './NewGraduateProfileSkillsAndPreferredConditionsContents';
import NewGraduateProfileSkillsAndPreferredConditionsForm from './NewGraduateProfileSkillsAndPreferredConditionsForm';
import useProfile from '../useProfile';
import { UpdateProfileCompletedModal } from '../Modals';

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 70px;

  ${media.mobile} {
    margin-bottom: 40px;
  }
`;

const ContentHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  margin-bottom: 16px;

  ${media.mobile} {
    margin-bottom: 12px;
  }
`;

const ContentCard = styled(Card)`
  width: 100%;
`;

type NewGraduateProfileSkillsAndPreferredConditionsProps = {
  formItems: ProfileFormItems;
};

const NewGraduateProfileSkillsAndPreferredConditions: FC<NewGraduateProfileSkillsAndPreferredConditionsProps> = props => {
  const { formItems } = props;
  const {
    canEdit,
    isEdit,
    handleShowContent,
    handleShowEdit,
    showUpdateProfileCompletedModal,
    openUpdateProfileCompletedModal,
    closeUpdateProfileCompletedModal,
  } = useProfile();

  return (
    <>
      <Wrapper>
        <ContentHead>
          <ProfileGroupLabel
            label={
              MESSAGES.PROFILE_SETTING
                .NEW_GRADUATE_PROFILE_SKILLS_AND_PREFERRED_CONDITIONS.LABEL
            }
            showInformation={isEdit}
          />
          {canEdit && !isEdit && (
            <ButtonS
              onClick={handleShowEdit}
              data-testid="button-edit-skills-and-preferred-conditions"
            >
              {MESSAGES.PROFILE_SETTING.BUTTON.EDIT}
            </ButtonS>
          )}
        </ContentHead>
        <ContentCard>
          {isEdit ? (
            <NewGraduateProfileSkillsAndPreferredConditionsForm
              formItems={formItems}
              onShowContent={handleShowContent}
              onOpenCompletedModal={openUpdateProfileCompletedModal}
            />
          ) : (
            <NewGraduateProfileSkillsAndPreferredConditionsContents />
          )}
        </ContentCard>
      </Wrapper>

      <UpdateProfileCompletedModal
        show={showUpdateProfileCompletedModal}
        onClose={closeUpdateProfileCompletedModal}
      />
    </>
  );
};

export default NewGraduateProfileSkillsAndPreferredConditions;
